export type ErrorResult = {
  error: string;
};

export function isErrorResult(object: any): object is ErrorResult {
  return typeof object === 'object' && object !== null && 'error' in object;
}
